import { render, staticRenderFns } from "./addSP.vue?vue&type=template&id=0c88e4e5"
import script from "./addSP.vue?vue&type=script&lang=js"
export * from "./addSP.vue?vue&type=script&lang=js"
import style0 from "./addSP.vue?vue&type=style&index=0&id=0c88e4e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports